// pnl config detail Types
export const TYPE_GROUP = 1
export const TYPE_TOTAL = 2

export const TYPE_NAMES = {
    1: 'Group',
    2: 'Total'
}


//pnl config detail account Source types
export const SOURCE_TYPE_ACCOUNT = 1
export const SOURCE_TYPE_PNL_CONFIG_DETAIL = 2

export const SOURCE_TYPE_NAMES = {
    1: 'Account',
    2: 'Pnl Config Detail'
}




export const MAIN_TYPE_PNL = 1
export const MAIN_TYPE_SURCHARGE = 2
export const MAIN_TYPE_RATIO_ANALYSIS = 3

export const MAIN_TYPE_NAMES = {
    1: 'Profit And Loss',
    2: 'Surcharge',
    3: 'Ratio Analysis'
}

export const MAIN_TYPE_OPTIONS = [
    {
        value: MAIN_TYPE_PNL,
        label: MAIN_TYPE_NAMES[MAIN_TYPE_PNL],
    },
    {
        value: MAIN_TYPE_SURCHARGE,
        label: MAIN_TYPE_NAMES[MAIN_TYPE_SURCHARGE],
    },
    {
        value: MAIN_TYPE_RATIO_ANALYSIS,
        label: MAIN_TYPE_NAMES[MAIN_TYPE_RATIO_ANALYSIS],
    }
]
